module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    class: {
      'modal-mask--responsive': _vm.modalResponsive,
      'modal-mask--flex-container': _vm.modalFlexContainer
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    ref: "modalContent",
    staticClass: "modal-container",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-modal": "true",
      "aria-label": _vm.ariaLabel || null
    }
  }, [_c('div', {
    staticClass: "modal-header",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("header", function() {
    return [_vm._v("default header")]
  }), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle close-cross",
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": _vm.$t('vue2.a11y.close')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('close')
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.$emit('close')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.$emit('close')
      }]
    }
  }, [_c('span', {
    staticClass: "icon-cross2 pointer",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_vm._v("\n          default body\n        ")]
  })], 2), _vm._v(" "), (_vm.isShowFooter) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "bttn create-btn right marg-10",
      on: {
        "click": function($event) {
          return _vm.$emit('submit')
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.submitTxt) + "\n          ")])]
  })], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d6c6e69!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AppModal.vue
// module id = 1947
// module chunks = 1